function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHollownessBetweenTileAndSubstrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.31,
    y: 30.56,
    width: 6.85,
    height: 38.88,
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.32,
    y: 46.57,
    width: 43.66,
    height: 6.85,
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.84,
    y: 30.56,
    width: 6.85,
    height: 38.88,
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.02,
    y: 46.58,
    width: 43.66,
    height: 6.85,
    style: {
      fill: "#E66C00"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHollownessBetweenTileAndSubstrate);
export default __webpack_public_path__ + "static/media/no-hollowness-between-tile-and-substrate.f930646ac88105de967283b64a74c8eb.svg";
export { ForwardRef as ReactComponent };